<template>
  <!-- eslint-disable vue/no-v-model-argument -->
  <WdsPageSignup class="wds-page-signup-login" nav-prev @prev="back">
    <template #left>
      <LeftWelcome />
    </template>

    <template #nav-right>
      <AuthLanguageSwitcher />
    </template>

    <template #right>
      <WdsHeading as="h1" type="title1">
        {{ $t('SAML SSO') }}
      </WdsHeading>

      <BaseHtmlForm action="/login" method="POST" class="tw-mt-8">
        <input name="request_type" value="saml" type="hidden" readonly />

        <WdsInput
          v-model="email"
          :error="errors.length === 0 ? undefined : errors.join('\n')"
          lg
          name="email"
          placeholder="Email Address"
          autofocus
          required
          type="email"
          data-test="saml-login-email-input"
        >
          <template #label>
            {{ $t('Email') }}
          </template>
        </WdsInput>

        <div class="tw-text-center tw-mt-6">
          <WdsButton primary full-width lg data-test="saml-login-login-button">
            {{ $t('Log in with SAML SSO') }}
          </WdsButton>
        </div>

        <div class="tw-text-center tw-mt-4">
          <WdsText primary full-width text-link="/login">
            <a href="/login" class="hover:tw-underline">
              {{ $t('Log in with email and password') }}
            </a>
          </WdsText>
        </div>
      </BaseHtmlForm>

      <WdsAlert
        info
        icon
        class="tw-mt-4"
        :title="$t('Make sure to use an email that is recognized as an ID in your organization.')"
      >
        <template #description>
          <p>{{ $t('This may be different than your contact email.') }}</p>
          <p>
            {{
              $t(
                "If you're unsure which email to use, or if you experience issues, please reach out to your organization's admin for assistance.",
              )
            }}
          </p>
        </template>
      </WdsAlert>
    </template>
  </WdsPageSignup>
</template>

<script lang="ts">
import {
  WdsAlert,
  WdsButton,
  WdsHeading,
  WdsInput,
  WdsPageSignup,
  WdsText,
} from '@worksome/wds-components'
import BaseHtmlForm from '@/components/BaseHtmlForm.vue'
import AuthLanguageSwitcher from '@/components/auth/AuthLanguageSwitcher.vue'
import LeftWelcome from '@/components/auth/left/LeftWelcome.vue'
import { $t } from '@/composables/translation'

export default {
  name: 'SamlLoginPage',
  components: {
    WdsAlert,
    BaseHtmlForm,
    AuthLanguageSwitcher,
    LeftWelcome,
    WdsButton,
    WdsHeading,
    WdsInput,
    WdsPageSignup,
    WdsText,
  },
  props: {
    errors: {
      type: Array,
      default: [],
    },
  },
  setup() {
    function back() {
      window.location.href = `${window.location.protocol}//${window.location.host}/login`
    }

    return {
      back,
      $t,
    }
  },
  data() {
    return {
      csrf: document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') ?? '',
      email: '',
    }
  },
}
</script>

<style scoped></style>
